module.exports = __webpack_public_path__ + "img/hr-dead-grey-trunk-08.1daa9124.png";